// Asynchronous steps of a report (dump → analyze → download), as stored in weekly_reports.steps.
export const isReportProcessing = (report) => {
  const steps = report?.steps;
  if (!steps) return false;
  return steps.dump === 'started'
    || steps.download?.status === 'started'
    || steps.analyze?.status === 'started';
};

export const isPublished = (report) => report?.status === 'published';

/** Changes whenever the analyzer makes progress: the cue to refetch the analyses. */
export const analyzeProgressKey = (report) => {
  const analyze = report?.steps?.analyze;
  return analyze ? `${analyze.status}:${analyze.analyzed_count ?? ''}` : '';
};
